import { createContext, useContext, useState } from 'react';

interface LocaleContextType {
  locale: string;
  setLocale: (locale: string) => void;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

// Get initial locale from URL query parameter
const getInitialLocale = (): string => {
  try {
    const params = new URLSearchParams(window.location.search);
    const localeParam = params.get('locale');
    
    if (!localeParam) {
      return 'en-US';
    }
    
    // Normalize locale based on first two language characters
    const languageCode = localeParam.toLowerCase().substring(0, 2);
    
    // Map language code to supported locale
    if (languageCode === 'fr') {
      return 'fr-CA';
    }
    
    // Default to English for all other cases
    return 'en-US';
  } catch (e) {
    return 'en-US';
  }
};

export const LocaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [locale, setLocale] = useState<string>(getInitialLocale());

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (context === undefined) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};
